export default {
  cardName: {
    isDirty: false,
    isEmpty: true,
    isFocused: false,
    errorMessages: ['is required'],
    isValid: false,
    name: 'cardName',
  },
  cardExpirationDate: {
    isDirty: false,
    isEmpty: true,
    isFocused: false,
    errorMessages: ['is required', 'is not a valid expiration date'],
    isValid: false,
    name: 'cardExpirationDate',
  },
  cardNumber: {
    isDirty: false,
    isEmpty: true,
    isFocused: false,
    errorMessages: ['is required', 'is not a valid card number'],
    isValid: false,
    last4: null,
    bin: null,
    name: 'cardNumber',
  },
  cardCvv: {
    isDirty: false,
    isEmpty: true,
    isFocused: false,
    errorMessages: ['is required', 'is not a valid security code'],
    isValid: false,
    name: 'cardCvv',
  },
};
